/**
 * Notification Tabs Component
 * Based on Figma design: Feed Sidebar tabs
 * Dark themed tab bar with 5 tabs: All, Rituality, Communities, Friends, You
 */

import { useTranslation } from "@/language"
import type { NotificationTab } from "../services/notification.service"

interface NotificationTabsProps {
  activeTab: NotificationTab
  onTabChange: (tab: NotificationTab) => void
}

export function NotificationTabs({ activeTab, onTabChange }: NotificationTabsProps) {
  const { t } = useTranslation("common")

  const tabs: { id: NotificationTab; label: string }[] = [
    { id: "all", label: t("notifications.tabs.all") },
    { id: "ritual", label: t("notifications.tabs.rituality") },
    { id: "communities", label: t("notifications.tabs.communities") },
    { id: "friends", label: t("notifications.tabs.friends") },
    { id: "you", label: t("notifications.tabs.you") },
  ]

  return (
    <div className="flex items-center gap-0 overflow-x-auto">
      {tabs.map(tab => (
        <TabButton
          key={tab.id}
          tab={tab.id}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  )
}

interface TabButtonProps {
  tab: NotificationTab
  label: string
  isActive: boolean
  onClick: () => void
}

function TabButton({ label, isActive, onClick }: TabButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex items-center gap-1 px-5 py-3.5 font-semibold text-[15px] uppercase tracking-wide transition-colors whitespace-nowrap leading-[25px]
        ${isActive ? "text-primary border-b-1 border-[#F2F0EB]" : "text-stone/50"}
      `}
    >
      {label}
    </button>
  )
}
